(function() {
  vtex.define('shipping/script/module/googleRequiredFields',[],function() {
    return function(address, googleDataMap, postalCodeRegex, storeAcceptsGeoCoords) {
      var invalidFields, requiredPostalCodeIsNotValid, requiredPropertyIsNull, rule, _i, _len;
      invalidFields = [];
      for (_i = 0, _len = googleDataMap.length; _i < _len; _i++) {
        rule = googleDataMap[_i];
        requiredPropertyIsNull = rule.required && !address[rule.value];
        requiredPostalCodeIsNotValid = !storeAcceptsGeoCoords && rule.value === 'postalCode' && !postalCodeRegex.test(address[rule.value]);
        if (requiredPropertyIsNull || requiredPostalCodeIsNotValid) {
          invalidFields.push(rule.value);
        }
      }
      return invalidFields;
    };
  });

}).call(this);

